import React, { Component } from 'react';
import counterpart from 'counterpart';
import './FormLabel.scss';

interface IFormLabel {
  /**
  * The input element associated with the form
  */
  target: string,
  /**
  * The label text
  */
  content: string,
  /**
   * enable or not the translation
   */
  shouldTranslate?: boolean,
  /**
   * The icon to be displayed
   */
  icon?: string,
  /**
   * additional classes
   */
  className?: string,
  /**
   * remove or not the bottom margin
   */
  noMargin?: boolean
}


class FormLabel extends Component<IFormLabel, any> {
  render() {
    const { target = "", content, shouldTranslate = true, icon = "", className = "", noMargin = false } = this.props;

    if (shouldTranslate) {
      return (
        <div className={`cc-form-label ${className} ${noMargin ? 'cc-form-label--nomargin' : ''}`}>
          {icon && <i className={`${icon} cc-form-label-icon`} />}
          <label htmlFor={target}>{counterpart(content)}</label>
        </div>
      );
    }

    return (
      <div className={`cc-form-label ${className} ${noMargin ? 'cc-form-label--nomargin' : ''}`}>
        {icon && <i className={`${icon} cc-form-label-icon`} />}
        <label htmlFor={target}>{content}</label>
      </div>
    );
  }
}

export default FormLabel;
